class SubCaseController {
  /* @ngInject */
  constructor($window, $stateParams, $http, $state, AllocateSubcaseService, Session, urls, moment) {
    this.$window = $window;
    this.$stateParams = $stateParams;
    this.$http = $http;
    this.$state = $state;
    this.AllocateSubcaseService = AllocateSubcaseService;
    this.Session = Session;
    this.urls = urls;
    this.moment = moment;
    this.caseId = this.$stateParams.id;

    this.datepickerOptions = {
    };

    this.tabIndexMap = {
      basicDetails: 0,
      employmentDetails: 1,
      addressDetails: 2,
      educationDetails: 3,
      miscDetails: 4,
    };

    this.steps = [true, true, true, true];
    this.forms = [];
    this.subCaseData = {};
    this.employmentData = {};
    this.educationData = {};
    this.currTabs = ['basicDetails'];
    this.showGapDetails = true;
  }

  $onInit() {
    this.isBetaUser = (this.Session.read('debug') || {}).userType === 'beta';

    this.$http
      .get(`/case/${this.caseId}`, { params: { config: true, caseResponse: true } })
      .then(({ data }) => {
        this.case = data;

        this.setUp();
      });
  }

  toggleBasicData(key, data) {
    if (!this.subCaseData[key]) {
      this.subCaseData[key] = data;
    } else {
      delete this.subCaseData[key];
    }
  }

  toggleEmpData(index, key, data) {
    const employment = this.employmentData[index] || {};

    if (!employment[key]) {
      employment[key] = data;
    } else {
      delete employment[key];
    }

    this.employmentData[index] = employment;
    this.subCaseData[`Employment ${index + 1}`] = employment;
  }

  toggleEduData(index, key, data) {
    const education = this.educationData[index] || {};

    if (!education[key]) {
      education[key] = data;
    } else {
      delete education[key];
    }

    this.educationData[index] = education;
    this.subCaseData[`Education ${index + 1}`] = education;
  }

  toggleMiscData(key, data) {
    const misc = this.subCaseData.Miscellaneous || {};

    if (!misc[key]) {
      misc[key] = data;
    } else {
      delete misc[key];
    }

    this.subCaseData.Miscellaneous = misc;
  }

  setUp() {
    this.caseConfig = this.case.config;
    this.identity = {
      Pan: [],
      Passport: [],
      Aadhaar: [],
      DrivingLicense: [],
    };
    this.educationAttch = [];
    this.employmentAttch = [];
    this.miscellaneousAttch = {
      Miscellaneous: [],
      Resume: [],
    };
    this.activeTab = 0;

    if (this.case && this.case.CaseResponse) {
      const { id: caseResponseId } = this.case.CaseResponse;
      this.data = this.case.CaseResponse.response;
      this.attachments = (this.case.CaseResponse.CaseResponseAttachments || [])
        .reduce((acc, a) => Object.assign(acc, { [a.id]: a }), {});

      this.data.employmentDetails.map((e, index) => {
        const attachments = (e.attachmentIds || []).map(i => ({
          id: i,
          filename: this.attachments[i].path.split('/').pop(),
          case_response_id: caseResponseId,
        }));

        Object.assign(e, { attachments });
        this.employmentAttch[index] = attachments;

        return e;
      });

      this.data.educationDetails.map((e, index) => {
        const attachments = (e.attachmentIds || []).map(i => ({
          id: i,
          filename: this.attachments[i].path.split('/').pop(),
          case_response_id: caseResponseId,
        }));

        Object.assign(e, { attachments });
        this.educationAttch[index] = attachments;

        return e;
      });

      Object.keys(this.identity).map(k => (
        this.case.CaseResponse.CaseResponseAttachments.map(a => {
          if (a.type === k) {
            this.identity[k].push({
              type: k,
              id: a.id,
              filename: a.path.split('/').pop(),
              case_response_id: caseResponseId,
            });

            return true;
          }

          return false;
        })
      ));

      this.data.educationDetails.map((e, index) => {
        const attachments = (e.attachmentIds || []).map(i => ({
          id: i,
          filename: this.attachments[i].path.split('/').pop(),
          case_response_id: caseResponseId,
        }));

        Object.assign(e, { attachments });
        this.educationAttch[index] = attachments;

        return e;
      });

      this.data.miscDetails = this.data.miscDetails || {
        uan: '',
        gapDetails: [],
        attachments: [],
        additionalInformation: '',
      };

      Object.keys(this.miscellaneousAttch).map(k => (
        this.case.CaseResponse.CaseResponseAttachments.map(a => {
          if (a.type === k) {
            this.miscellaneousAttch[k].push({
              type: k,
              id: a.id,
              filename: a.path.split('/').pop(),
              case_response_id: caseResponseId,
            });

            return true;
          }

          return false;
        })
      ));

      this.modifyBasicDetailsAttach();
      this.modifyEducationAttach();
      this.modifyEmploymentAttach();
      this.modifyMiscellaneousAttach();
    } else {
      this.data = {
        basicDetails: {
          fullName: this.case.full_name,
          lastName: this.case.last_name,
          nationality: 'Indian',
        },
        employmentDetails: [{

        }],
        addressDetails: {
          residential: [{}],
          employment: [{}],
        },
        educationDetails: [{

        }],
        miscDetails: {
          uan: '',
          gapDetails: [],
          attachments: [],
          additionalInformation: '',
        },
      };
    }

    this.setPreConditions();
  }

  setEmploymentPre() {
    const employmentCheck = this.caseConfig.employmentCheck;
    const empCheck = employmentCheck.selected;
    const empRefCheck = this.caseConfig.employmentReferenceCheck.selected;
    this.showEmploymentTab = empCheck || empRefCheck;

    if (this.showEmploymentTab) {
      this.currTabs.push('employmentDetails');

      const empCheckMaxEmp = empCheck && employmentCheck.maxEmployments;
      this.maxEmploymentYear = Math.max(
        empCheck && employmentCheck.maxYears,
        empRefCheck && this.caseConfig.employmentReferenceCheck.maxYears
      );

      this.maxEmployment = empCheckMaxEmp || 20;
      this.employmentLabel = `${
        this.maxEmploymentYear ? `Last ${this.maxEmploymentYear} year(s)` : ''
      }${(this.maxEmploymentYear && empCheckMaxEmp) ? ' - ' : ''}${
        empCheckMaxEmp ? `Upto ${empCheckMaxEmp} employment(s)` : ''}`;
    }
  }

  setAddressPre() {
    const criminalPoliceCheck = this.caseConfig.criminalPoliceCheck;
    const criminalCourtRecordCheck = this.caseConfig.criminalCourtRecordCheck;
    const eCourtRecordCheck = this.caseConfig.eCourtRecordCheck;
    const addressCheck = this.caseConfig.addressCheck;
    const digitalAddressCheck = this.caseConfig.digitalAddressCheck;
    const creditScoreCheck = this.caseConfig.creditScoreCheck;

    const criminalPoliceCheckEnabled = criminalPoliceCheck.selected;
    const criminalCourtRecordCheckEnabled = criminalCourtRecordCheck.selected;
    const eCourtRecordCheckEnabled = eCourtRecordCheck.selected;
    const addressCheckEnabled = addressCheck.selected;
    const digitalAddressCheckEnabled = digitalAddressCheck.selected;

    this.showAddrTab = criminalPoliceCheckEnabled
      || addressCheckEnabled
      || digitalAddressCheckEnabled
      || criminalCourtRecordCheckEnabled
      || eCourtRecordCheckEnabled
      || creditScoreCheck.selected;

    if (this.showAddrTab) {
      this.currTabs.push('addressDetails');
      this.showResAddr =
        addressCheck.isResidentialAddressCheck ||
        digitalAddressCheck.isResidentialAddressCheck ||
        criminalPoliceCheck.isResidentialAddressCheck.selected ||
        criminalCourtRecordCheck.isResidentialAddressCheck.selected ||
        eCourtRecordCheck.isResidentialAddressCheck.selected ||
        (
          creditScoreCheck.selected && creditScoreCheck.isResidentialAddressCheck.selected
        );

      this.showPermAddr =
        addressCheck.isPermanentAddressCheck ||
        digitalAddressCheck.isPermanentAddressCheck ||
        criminalPoliceCheck.isPermanentAddressCheck ||
        criminalCourtRecordCheck.isPermanentAddressCheck ||
        eCourtRecordCheck.isPermanentAddressCheck;

      this.showEmpAddr =
        (criminalPoliceCheckEnabled && criminalPoliceCheck.isEmploymentAddressCheck.selected)
        || (
          criminalCourtRecordCheckEnabled &&
          criminalCourtRecordCheck.isEmploymentAddressCheck &&
          criminalCourtRecordCheck.isEmploymentAddressCheck.selected
        )
        || (
          eCourtRecordCheckEnabled &&
          eCourtRecordCheck.isEmploymentAddressCheck &&
          eCourtRecordCheck.isEmploymentAddressCheck.selected
        );

      if (this.showEmpAddr) {
        this.empAddrYears = Math.max(
          (
            criminalPoliceCheckEnabled
            && criminalPoliceCheck.isEmploymentAddressCheck
            && criminalPoliceCheck.isEmploymentAddressCheck.selected
            && criminalPoliceCheck.isEmploymentAddressCheck.maxYears
          ),
          (
            criminalCourtRecordCheckEnabled
            && criminalCourtRecordCheck.isEmploymentAddressCheck
            && criminalCourtRecordCheck.isEmploymentAddressCheck.selected
            && criminalCourtRecordCheck.isEmploymentAddressCheck.maxYears
          ),
          (
            eCourtRecordCheckEnabled
            && eCourtRecordCheck.isEmploymentAddressCheck
            && eCourtRecordCheck.isEmploymentAddressCheck.selected
            && eCourtRecordCheck.isEmploymentAddressCheck.maxYears
          )
        );
      }
      this.showAddressRange = criminalCourtRecordCheckEnabled || eCourtRecordCheckEnabled;

      if (this.showResAddr) {
        this.resAddrYears = Math.max(
          (
            criminalPoliceCheckEnabled
            && criminalPoliceCheck.isResidentialAddressCheck
            && criminalPoliceCheck.isResidentialAddressCheck.maxYears
          ),
          (
            criminalCourtRecordCheckEnabled
            && criminalCourtRecordCheck.isResidentialAddressCheck
            && criminalCourtRecordCheck.isResidentialAddressCheck.maxYears
          ),
          (
            eCourtRecordCheckEnabled
            && eCourtRecordCheck.isResidentialAddressCheck
            && eCourtRecordCheck.isResidentialAddressCheck.maxYears
          )
        );
      }
    }
  }

  setMiscPre() {
    this.showGapDetails = true;
    this.showUANDetails = this.caseConfig.uanCheck && this.caseConfig.uanCheck.selected;
  }

  setPreConditions() {
    this.setEmploymentPre();
    this.setAddressPre();
    this.setMiscPre();
    this.showIdentity = this.caseConfig.identity.selected;
    this.showEducationTab = this.caseConfig.education.selected;

    if (this.showEducationTab) {
      this.maxEducation = this.caseConfig.education.maxEducations;
      this.currTabs.push('educationDetails');
    }

    if (
      (this.caseConfig.creditScoreCheck
      && this.caseConfig.creditScoreCheck.selected)
      || (this.caseConfig.globalDatabaseCheck
      && this.caseConfig.globalDatabaseCheck.selected)
      || (this.caseConfig.indianDatabaseCheck
      && this.caseConfig.indianDatabaseCheck.selected)
      || (this.caseConfig.criminalPoliceCheck
      && this.caseConfig.criminalPoliceCheck.selected)
      || (this.caseConfig.criminalCourtRecordCheck
      && this.caseConfig.criminalCourtRecordCheck.selected)
      || (this.caseConfig.eCourtRecordCheck
      && this.caseConfig.eCourtRecordCheck.selected)
    ) {
      this.isPanAadharRequired = true;
    }

    this.currTabs.push('miscDetails');
  }

  modifyBasicDetailsAttach() {
    this.data.basicDetails.attachments = [];
    Object.entries(this.identity)
      .forEach(([key, value]) => {
        if (value && Object.keys(value).length) {
          const attachments = angular.isArray(value) ? value : [value];
          this.data.basicDetails.attachments = this.data.basicDetails.attachments.concat(
            attachments.map(v => ({
              type: key,
              file: v,
            }))
          );
        }
      });
  }

  modifyEducationAttach() {
    this.data.educationDetails
      .forEach((v, i) => {
        if (this.educationAttch[i]) {
          Object.assign(v, {
            attachments: this.educationAttch[i].map(file => ({
              file,
              type: 'Degree',
            })),
          });
        }
      });
  }

  modifyEmploymentAttach() {
    this.data.employmentDetails
      .forEach((v, i) => {
        if (this.employmentAttch[i]) {
          Object.assign(v, {
            attachments: this.employmentAttch[i].map(file => ({
              file,
              type: 'Employment',
            })),
          });
        }
      });
  }

  modifyMiscellaneousAttach() {
    this.data.miscDetails.attachments = [];
    Object.entries(this.miscellaneousAttch)
      .forEach(([key, value]) => {
        if (value && Object.keys(value).length) {
          const attachments = angular.isArray(value) ? value : [value];
          this.data.miscDetails.attachments = this.data.miscDetails.attachments.concat(
            attachments.map(v => ({
              type: key,
              file: v,
            }))
          );
        }
      });
  }

  indexValue(tabName) {
    return this.currTabs.findIndex(v => v === tabName) + 1;
  }

  stepNext(currentStep, currTabName) {
    const nextTabName = this.currTabs[this.currTabs.findIndex(v => v === currTabName) + 1];
    const nextTabIndex = this.tabIndexMap[nextTabName];

    if (!nextTabName) return this.submit();

    this.steps[nextTabIndex] = true;
    this.activeTab = nextTabIndex;
    this.$window.scrollTo(0, 0);

    return true;
  }

  tabPillClass(currentStep) {
    const className = ['b-a b-3x'];
    const form = this.forms[currentStep];

    if (this.activeTab === currentStep) className.push('bg-info font-bold');
    if (form) {
      if (form.$submitted && !form.$invalid) {
        className.push('b-success');
      }

      if (form.$dirty && form.$invalid) className.push('b-danger');

      return className.join(' ');
    }

    return '';
  }

  openAllocationModal() {
    if (!Object.keys(this.subCaseData).length) {
      this.errorMsg = 'Select atleast 1 data';
      return;
    }

    this.AllocateSubcaseService.open(this.caseId, this.subCaseData);
  }
}

export default SubCaseController;



// WEBPACK FOOTER //
// ./client/app/cases/newSubCase/newSubCase.controller.js